import { TableCell, TableRow, tableCellClasses, Toolbar, OutlinedInput } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DateRange } from 'react-date-range';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    textTransform: 'uppercase',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    fontSize: 11,
    fontWeight: 500,
    padding: '0px 6px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px'
  }
}));

export const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 45,
  display: 'flex',
  justifyContent: 'space-between'
  // padding: '0 !important'
}));

export const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  paddingTop: 2,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

export const DateRangeStyled = styled(DateRange)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  border: '1px solid #ddd',
  background: '#eee',
  zIndex: 10
}));
